var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DealershipApplicationsList',{attrs:{"items":_vm.applications,"headers":_vm.applicationsListHeaders,"pagination-data":_vm.paginationData,"is-loading":_vm.isLoading},on:{"pageChange":_vm.getData,"onClickRow":_vm.onClickRow}})
}
var staticRenderFns = []

export { render, staticRenderFns }